import { Typography } from "@mui/material";
import { Column } from "../../misc/Column";
import { Money } from "../../misc/Money";

export const DunningColumnFooter = ({ amount, title }: { amount: number; title: string }) => {
  return (
    <Column alignItems="center">
      <Money cents={amount} style={{ fontSize: "14px", fontWeight: 600 }} />
      <Typography variant="body1" color="text.secondary">
        {title}
      </Typography>
    </Column>
  );
};
